const HisInjection = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};

  return (
    <svg
      style={_sx}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17 2C17 2.41538 17 2.62307 17.0399 2.81988C17.0911 3.07226 17.1906 3.31238 17.3328 3.52705C17.4438 3.69445 17.5906 3.84131 17.8844 4.13502L19.8654 6.11612C20.1587 6.40937 20.3053 6.55599 20.4724 6.66681C20.6874 6.80936 20.9279 6.90899 21.1807 6.9602C21.3773 7 21.5846 7 21.9993 7"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M17 12L9.5 19.5L4.5 14.5L12 7"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 5.5L18.5 13.5"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M7.99998 18.6372L6.00012 20L4.00012 18L5.3628 16"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M13.5 8L18.5 4M16 10.5L20 5.5"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M5 19L2 22"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default HisInjection;
